import { DefaultTheme } from 'styled-components'

const defaultColors = {
  black: '#000',
  white: '#fff',
  yellow600: '#fabf40',
  grey600: '#333',
  green600: '#43a047',
  orange600: '#fb8c00',
  red600: '#e53935',
  blue600: '#1e88e5',
}
export const theme: DefaultTheme = {
  radius: {
    small: '2px',
    medium: '5px',
    large: '10px',
    none: '0px',
  },

  colors: {
    black: defaultColors.black,
    white: defaultColors.white,
    yellow: defaultColors.yellow600,
    orange: defaultColors.orange600,
    green: defaultColors.green600,
    red: defaultColors.red600,
    blue: defaultColors.blue600,
    grey: defaultColors.grey600,

    yellow50: '#fff9ea',
    yellow100: '#feecc0',
    yellow200: '#fde096',
    yellow300: '#fdd981',
    yellow400: '#fccd57',
    yellow500: '#fbc02d',
    yellow600: '#fabf40',
    yellow700: '#eeb11a',
    yellow800: '#d6a326',
    yellow900: 'c28c08',

    grey50: '#f8f9f9',
    grey100: '#edeff0',
    grey200: '#e2e4e6',
    grey300: '#d6dadc',
    grey400: '#838c91',
    grey500: '#676d70',
    grey600: '#333',
    grey700: '#222',
    grey800: '#111',
    grey900: '#000',

    green50: '#e8f5e9',
    green100: '#c8e6c9',
    green200: '#a5d6a7',
    green300: '#81c784',
    green400: '#66bb6a',
    green500: '#4caf50',
    green600: '#43a047',
    green700: '#388e3c',
    green800: '#2e7d32',
    green900: '#1b5e20',

    blue50: '#e3f2fd',
    blue100: '#bbdefb',
    blue200: '#90caf9',
    blue300: '#64b5f6',
    blue400: '#64b5f6',
    blue500: '#2196f3',
    blue600: '#1e88e5',
    blue700: '#1976d2',
    blue800: '#1565c0',
    blue900: '#0d47a1',

    red50: '#ffebee',
    red100: '#ffcdd2',
    red200: '#ef9a9a',
    red300: '#e57373',
    red400: '#ef5350',
    red500: '#f44336',
    red600: '#e53935',
    red700: '#d32f2f',
    red800: '#c62828',
    red900: '#b71c1c',

    orange50: '#fff3e0',
    orange100: '#ffe0b2',
    orange200: '#ffcc80',
    orange300: '#ffb74d',
    orange400: '#ffa726',
    orange500: '#ff9800',
    orange600: '#fb8c00',
    orange700: '#f57c00',
    orange800: '#ef6c00',
    orange900: '#e65100',
  },

  screenSize: {
    mobile: '600px',
    tablet: '900px',
    computer: '1024px',
  },

  fontWeight: {
    light: '300',
    normal: '400',
    bold: '600',
  },
  inputFieldHeight: '38px',
}

const darkColors = {
  black: '#AEAEB2',
  white: '#1C1C1E',
  yellow600: '#fabf40',
  grey600: '#78716c',
  green600: '#43a047',
  orange600: '#78716c',
  red600: '#e53935',
  blue600: '#1e88e5',
}
export const darkTheme: DefaultTheme = {
  radius: {
    small: '2px',
    medium: '5px',
    large: '10px',
    none: '0px',
  },

  colors: {
    black: darkColors.black,
    white: darkColors.white,
    yellow: defaultColors.black,
    orange: darkColors.orange600,
    green: defaultColors.green600,
    red: defaultColors.red600,
    blue: defaultColors.blue600,
    grey: darkColors.grey600,

    yellow50: '#fff9ea',
    yellow100: '#feecc0',
    yellow200: '#fde096',
    yellow300: '#fdd981',
    yellow400: '#fccd57',
    yellow500: '#fbc02d',
    yellow600: '#000',
    yellow700: '#eeb11a',
    yellow800: '#d6a326',
    yellow900: 'c28c08',

    grey50: "#fff",
    grey100:"#fff",
    grey200:"#fff",
    grey300:"#fff",
    grey400:"#fff",
    grey500:"#fff",
    grey600:"#fff",
    grey700:"#fff",
    grey800:"#fff",
    grey900:"#fff",

    green50: '#e8f5e9',
    green100: '#c8e6c9',
    green200: '#a5d6a7',
    green300: '#81c784',
    green400: '#66bb6a',
    green500: '#4caf50',
    green600: '#43a047',
    green700: '#388e3c',
    green800: '#2e7d32',
    green900: '#1b5e20',

    blue50: "#fff",
    blue100:"#fff",
    blue200:"#fff",
    blue300:"#fff",
    blue400:"#fff",
    blue500:"#fff",
    blue600:"#fff",
    blue700:"#fff",
    blue800:"#fff",
    blue900:"#fff",

    red50: '#ffebee',
    red100: '#ffcdd2',
    red200: '#ef9a9a',
    red300: '#e57373',
    red400: '#ef5350',
    red500: '#f44336',
    red600: '#e53935',
    red700: '#d32f2f',
    red800: '#c62828',
    red900: '#b71c1c',

    orange50: '#fff3e0',
    orange100: '#ffe0b2',
    orange200: '#ffcc80',
    orange300: '#ffb74d',
    orange400: '#ffa726',
    orange500: '#ff9800',
    orange600: '#fb8c00',
    orange700: '#f57c00',
    orange800: '#ef6c00',
    orange900: '#e65100',
  },

  screenSize: {
    mobile: '600px',
    tablet: '900px',
    computer: '1024px',
  },

  fontWeight: {
    light: '300',
    normal: '400',
    bold: '600',
  },
  inputFieldHeight: '38px',
}